<template>
  <div>
    <h1 class="ts-text-3xl ts-font-bold ts-font-heading-font">{{ $t('dashboard.pageTitle') }}</h1>
    <small class="ts-text-xs ts-m-1">{{ $t('dashboard.welcomeBack') }}</small>
    <!-- <h1 class="ts-text-base ts-mt-10">{{ $t('dashboard.quickStat') }}</h1> -->
    <div class="ts-grid ts-grid-cols-1 lg:ts-grid-cols-3 ts-gap-5 ts-mt-3">
      <div class="lg:ts-col-span-2">
        <TotalDealer />
        <div class="ts-w-full ts-bg-white ts-mt-5 ts-rounded-lg" style="height:320px">
          
        </div>
      </div>
      <div class="ts-col-span-1">
        <Betting />
        <Balance class="ts-mt-5" />
      </div>
    </div>
  </div>
</template>

<script>
import Betting from './dashboard-component/betting'
import Balance from './dashboard-component/balance'
import TotalDealer from './dashboard-component/total-dealer'
export default {
  name: 'Dashboard',
  components: {
    Betting,
    Balance,
    TotalDealer
  },
  data() {
    return {
      date: null,
      fileModel: null,
      time: null
    }
  },
  methods: {
    async deleteSomething() {
      if (await this.$confirmModal.danger('Are you sure to delete?')) {
        this.$toasted.success('Deleted')
      }
    }
  }
}
</script>
